import { render, staticRenderFns } from "./TabComplementaInformacion.vue?vue&type=template&id=3e379e63&scoped=true"
import script from "./TabComplementaInformacion.vue?vue&type=script&lang=js"
export * from "./TabComplementaInformacion.vue?vue&type=script&lang=js"
import style0 from "./TabComplementaInformacion.vue?vue&type=style&index=0&id=3e379e63&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e379e63",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e379e63')) {
      api.createRecord('3e379e63', component.options)
    } else {
      api.reload('3e379e63', component.options)
    }
    module.hot.accept("./TabComplementaInformacion.vue?vue&type=template&id=3e379e63&scoped=true", function () {
      api.rerender('3e379e63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabComplementaInformacion.vue"
export default component.exports